<template>
  <v-card class="main-container">
    <v-tabs v-model="current_ref_type_id" fixed-tabs>
      <v-tab v-for="ref_type in ref_types" :key="ref_type.id">{{ ref_type.descr}}</v-tab>
    </v-tabs>

    <v-card-text>
      <div v-if="GETTERS_LOGIN">
        <v-list class="d-flex align-center justify-start">
          <v-list-item>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              single-line
              x-small
              label="поиск:"
              color="#15336d"
            ></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-btn
              @click="addNew()"
              x-small>
                добавить запись
            </v-btn>
          </v-list-item>
        </v-list>

        <v-data-table
            :style="{color: $mainColor}"
            :headers="headers[current_ref_type_id]"
            :items="(search_data.length > 0 ? search_data : data)"
            item-key="id"
            dense
            :loading="preloaderYet"
            :loading-text="$t('User.loading_orders')"
            :items-per-page="20"
            :footer-props="{
                itemsPerPageOptions: [20, 50, -1],
                itemsPerPageText: 'кол-во на стр.:',
            }"
        >
          <template v-slot:body="{ items, isSelected, select}">
            <tbody>
              <tr v-for="item in items" :key="item.id" :class="row_classes(item)" style="cursor: pointer;" @click="open_card(item)">
                <td v-for="header in headers[current_ref_type_id]">
                  <span v-if="header['value'] != 'actions'">
                        {{ item[header['value']] }}
                  </span>
                </td>
                <!-- <td>
                  <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                          <v-icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="setDisable(item)">
                          mdi-delete
                          </v-icon>
                      </template>
                      <span>отключить</span>
                  </v-tooltip>
                </td> -->
              </tr>
            </tbody>
          </template>
        </v-data-table>

      </div>
    </v-card-text>

    <v-dialog v-model="modal_card" persistent max-width="700">
      <ref-card
        :current_ref_type="this.ref_types[this.current_ref_type_id]"
        :card_data="selected_data"
        @closeDialog="modal_card=false"
        @reloadLists="loadReference()"
      />
    </v-dialog>

  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import RefCard from "../components/Reference/RefCard.vue";

export default {
  name: 'Reference',

  components: {
    RefCard,
  },

  data() {
    return {
      current_ref_type_id: 0,
      selected_data: {},

      ref_types: [
        {id: 0, descr: 'Организации', bd_name: 'organization'},
        {id: 1, descr: 'Должности', bd_name: 'orgposition'},
      ],

      headers: [
        [
          { text: 'ID', align: 'start', sortable: true, value: 'id'},
          { text: 'Название', sortable: true, value: 'name'},
          { text: 'Сокращенное название', sortable: true, value: 'abbreviation'},
          { text: 'Название EN', sortable: true, value: 'name_en'},
          { text: 'Сокращенное название EN', sortable: true, value: 'abbreviation_en'},
          // { text: this.$t('actions'), value: 'actions', sortable: false},
        ],
        [
          { text: 'ID', align: 'start', sortable: true, value: 'id'},
          { text: 'Позиция', sortable: true, value: 'title'},
          // { text: this.$t('actions'), value: 'actions', sortable: false},
        ],
      ],

      data: [],
      search_data: [],

      search: '',
      preloaderYet: false,
      modal_card: false,
    };
  },

  async beforeMount() {
    this.loadReference();
  },

  methods:{
    ...mapActions([
      'GET_REFERENCE',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    loadReference() {
      this.UPDATE_OVERLAY(true)
      this.preloaderYet = true
      this.GET_REFERENCE({bd_name: this.ref_types[this.current_ref_type_id]['bd_name']})
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          this.preloaderYet = false
          this.data = res.data;
          this.make_search()
        })
        .catch(() => {
          this.UPDATE_OVERLAY(false)
          this.preloaderYet = false
        });
    },

    addNew(){
      this.selected_data = {}
      this.modal_card = true
    },

    open_card(item){
      this.selected_data = JSON.parse(JSON.stringify(item))
      this.modal_card = true
    },

    row_classes(item) {
      if(item.is_active == false)
        return "gray_bg";
      else
          return "";
    },

    make_search(){
      if (this.search.length === 0) {
        this.search_data = []
      }
      else{
        this.search_data = this.data.filter(item => {
          var f1 = false, f2 = false, f3 = false
          if (item.name !== undefined && item.name !== null) {
            f1 = item.name.toLowerCase().includes(this.search.toLowerCase())
          }
          if (item.abbreviation !== undefined && item.abbreviation !== null) {
            f2 = item.abbreviation.toLowerCase().includes(this.search.toLowerCase())
          }
          if (item.title !== undefined && item.title !== null) {
            f3 = item.title.toLowerCase().includes(this.search.toLowerCase())
          }
          return f1 || f2 || f3
        })
      }
    },
  },

  computed: mapGetters([
    'GETTERS_LOGIN',
  ]),

  watch: {
    current_ref_type_id(val) {
      this.data = []
      this.search = ''
      this.loadReference()
    },

    search(val) {
      this.make_search()
    },

  }

};
</script>
